import React from "react";
import { PropTypes } from 'prop-types';
import { Row, Col, Radio, Tooltip } from "antd";
import {
  ValueDataHeading,
  UnderlyingContent,
  ContentDivider 
} from '../../../../Epics/Grants/Pages/RecommendGrant/style';
import { addressFormat } from '../../../../Epics/Grants/Pages/RecommendGrant/utils';
import { DisplayFlex, DataHeading } from "../../../commonStyles";

CharitySelect.propTypes = {
  data: PropTypes.shape({
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.any,
    addressLine3: PropTypes.any,
    charityContactFirstName: PropTypes.any,
    charityContactLastName: PropTypes.any,
    city: PropTypes.string,
    country: PropTypes.string,
    ein: PropTypes.string,
    email: PropTypes.any,
    encryptedEin: PropTypes.any,
    encryptedLastFourDigitsEin: PropTypes.any,
    granteeOrg: PropTypes.any,
    granteeOrgAliasId: PropTypes.number,
    granteeOrgId: PropTypes.string,
    hashForEin: PropTypes.any,
    hashForLastFourEin: PropTypes.any,
    interestArea: PropTypes.string,
    interestAreaId: PropTypes.number,
    legalName: PropTypes.string,
    phoneNumber: PropTypes.any,
    shortName: PropTypes.any,
    state: PropTypes.string,
    stateType: PropTypes.any,
    zip: PropTypes.string,
  }),
  onRadioChange: PropTypes.func,
  granteeOrgId: PropTypes.string,
}

export default function CharitySelect({
  data,
  onRadioChange,
  granteeOrgId
}) {
  return (
    <div>
      <Row type="flex">
        <Col span={24}>
          <DisplayFlex>
            <Radio
              data-test="test-radio"
              className="mr1"
              name="multipleCharityRadio"
              value={data.granteeOrgId}
              checked={granteeOrgId === data.granteeOrgId}
              onChange={() => onRadioChange(data.granteeOrgId, data)}
            />
            <DataHeading>{data.legalName}</DataHeading>
          </DisplayFlex>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={12}>
          <DataHeading>EIN</DataHeading>
          <ValueDataHeading>{data.ein}</ValueDataHeading>
        </Col>
        <Col span={12}>
          <DataHeading>Address</DataHeading>
          <Tooltip placement="bottom" title={addressFormat({
            ...data,
            zipCode: data.zip
          })}>
            <UnderlyingContent>{`${data.city}, ${data.state}`}</UnderlyingContent>
          </Tooltip>
        </Col>
      </Row>
      <ContentDivider />
      <Row>
        <Col span={23}>
          <DataHeading>Interest Area</DataHeading>
          <ValueDataHeading>{data.interestArea}</ValueDataHeading>
        </Col>
      </Row>
    </div>
  );
}